"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-".concat(position);
}